var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgReleaseNotes = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#868686",
    d: "M12.2,20.29a5.51,5.51,0,0,1-2.15-.55.38.38,0,0,0-.51.2.29.29,0,0,0,0,.18l.17,2.55a.2.2,0,0,0,.22.18l.1,0,.72-.55a.2.2,0,0,1,.28,0h0l1,1.6a.2.2,0,0,0,.28.06l0-.06,1-1.6a.2.2,0,0,1,.28,0h0l.72.54a.19.19,0,0,0,.28,0,.36.36,0,0,0,0-.09l.17-2.55a.39.39,0,0,0-.36-.42.39.39,0,0,0-.18,0A5.5,5.5,0,0,1,12.2,20.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#868686",
    d: "M19.28,13.85l-2.4-2.45C16.88,3.5,12.22,0,12.22,0s-4.7,3.5-4.7,11.4l-2.4,2.45a.38.38,0,0,0-.11.36l.92,5.59a.37.37,0,0,0,.42.33.49.49,0,0,0,.17-.06L9.87,17.8a3.84,3.84,0,0,0,2.36,1,3.63,3.63,0,0,0,2.3-1l3.35,2.27a.37.37,0,0,0,.53-.11.44.44,0,0,0,.06-.16l.93-5.6A.46.46,0,0,0,19.28,13.85Zm-7.06-5a1.6,1.6,0,1,1,1.53-1.66s0,0,0,.06a1.57,1.57,0,0,1-1.54,1.6Z"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: 24,
    height: 24
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgReleaseNotes, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/release_notes.0fda77be.svg";
export { ForwardRef as ReactComponent };